<template>
  <li
    :class="{ '-active': isActive, '-show-children': showChildren }"
    class="sidebar-item"
  >
    <a
      :href="href"
      @click="hasChildren ? toggleShowChildren() : navigate($event)"
      class="link"
    >
      <span class="icon"><ion-icon :name="icon"></ion-icon></span>
      <span class="title">
        <slot></slot>
      </span>

      <span class="dropdown" v-if="hasChildren">
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </span>
    </a>

    <transition name="slide-menu-down" v-if="hasChildren">
      <ul class="menuChildren" v-if="showChildren"><slot name="children"></slot></ul>
    </transition>
  </li>
</template>

<script>
export default {
  name: 'SidebarItem',

  props: {
    href: {
      type: String,
      required: false,
      default: '#',
    },
    isActive: {
      type: Boolean,
      required: false,
    },
    icon: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showChildren: false,
    };
  },

  methods: {
    /**
     * Navigate the url
     *
     * @param e
     */
    navigate(e) {
      this.$emit('click', e);
    },

    /**
     * Toggle the show children, defining the opposite of actual
     * status from property showChildren.
     */
    toggleShowChildren() {
      this.showChildren = !this.showChildren;
    },
  },

  computed: {
    /**
     * Item has children.
     *
     * @returns {boolean}
     */
    hasChildren() {
      return !!this.$slots.children;
    },
  },

  watch: {
    isActive(isActive) {
      if (isActive && this.hasChildren) {
        this.showChildren = true;
      }
    },
  },

  mounted() {
    if (this.isActive && this.hasChildren) {
      this.showChildren = true;
    }
  },
};
</script>

<style lang="scss" scoped>
  .sidebar-item {
    display: block;
    width: 100%;
    padding: 0 20px;

    > .link {
      display: block;
      padding: 10px 15px;
      position: relative;
      color: theme('colors.secondary.700');
      border-radius: 10px;
      font-weight: 500;
      margin: 5px 0;
      outline: none;

      > .title {
        font-weight: 600;
        letter-spacing: .05em;
        font-size: .75rem;
      }

      > .icon {
        padding-right: 10px;
        position: relative;
        top: 2px;
      }

      > .dropdown {
        position: absolute;
        right: 15px;
        top: 12px;
        display: block;
      }
    }

    > .menuChildren {
      width: 100%;
      position: relative;
      padding-left: 20px;

      &:after {
        position: absolute;
        content: '';
        width: 1px;
        height: 100%;
        background-color: #ddd;
        top: 0;
        left: 30px;
        z-index: -1;
      }
    }

    &.-active {
      .link {
        background: linear-gradient(45deg, theme('colors.primary.500') 0%, #cc05a6 100%);
        position: relative;
        box-shadow: 0px 0px 12px 0px rgba(115, 102, 255, 0.35);
        color: #ffffff;
      }
    }

    &.-show-children {
      > .link {
        > .dropdown {
          transform: rotate(90deg);
        }
      }
    }

    &:hover:not(.-active),
    &.-show-children:not(.-active) {
      > .link {
        color: theme('colors.primary.900');
      }
    }
  }
</style>
